import React from 'react';

const Story = () => {
    return (
        <div>
            <h2>This is Story Page</h2>
        </div>
    );
};

export default Story;